(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('fr')) return;
  const watched = new WeakSet();
  const original = 'Powered by Revoq – EU Withdrawal Button';
  function update(root) {
    root.querySelectorAll('.widerruf-form-branding__text').forEach(el => {
      if (el.textContent.trim() === original) el.textContent = 'Propulsé par Revoq – Bouton de rétractation européen';
    });
  }
  function watch(root) {
    if (watched.has(root)) return;
    watched.add(root);
    update(root);
    new MutationObserver(() => update(root)).observe(root, {childList:true,subtree:true,characterData:true});
  }
  function findForm() {
    document.querySelectorAll('[data-widerruf-popup-active-host]').forEach(host => {
      if (host.shadowRoot) watch(host.shadowRoot);
    });
  }
  watch(document.body);
  findForm();
  new MutationObserver(findForm).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['data-widerruf-popup-active-ready']});
})();